// ============================================================
// TILT : MarkCorner.js     THE MARK CHIP, with friends inside   (caP'n, 2026-10-25)
// Calm moments only: it shows on the title, the table pickers, the loadout and the gauntlet, and steps away whenever the
// friends layer does (a table is live: App.js calls setSocialHidden(screen === "solo" || screen === "duel")).
// Signed OUT it is the one quiet "PLAY WITH FRIENDS" chip that opens the sign-in card. Signed IN it is your nameplate
// (click: your Mark, then the editor) with the friends heart attached (MarkChipSocial.js). There is no separate friends pill.
// ============================================================
import React, { useState, useEffect } from "react";
import { useIEAuth } from "./ieIdentity";
import { useSocialHidden } from "./ieSocial";
import Mark from "./Mark";
import MarkEditor from "./MarkEditor";
import MarkFriendsChip from "./MarkChipSocial";
import { GAME_ID, SignInCard, ONLINE_MODAL } from "./tiltOnline";
import { UI, PANEL, RAISED, facetTB } from "./theme";

export default function MarkCorner() {
  const hidden = useSocialHidden();
  const auth = useIEAuth({ gameId: GAME_ID, createProfile: true });
  const markUid = auth.uid;
  const mine = auth.writable && auth.phase === "ready";
  const [markView, setMarkView] = useState(null);       // null | "view" | "edit"
  const [signIn, setSignIn] = useState(false);
  // a table going live closes anything open here, so a card can never be left up over play
  useEffect(() => { if (hidden) { setMarkView(null); setSignIn(false); } }, [hidden]);
  ONLINE_MODAL.open = !hidden && (signIn || !!markView);      // game keys wait while a card about YOU is up
  if (hidden) return null;
  return (
    <>
      <div style={{ position: "fixed", top: 18, right: 20, zIndex: 20 }}>
        {markUid && (mine || !auth.writable)
          ? <MarkFriendsChip uid={markUid} dense onOpenMark={() => setMarkView("view")} />
          : auth.phase !== "boot" && (
            <div onClick={() => setSignIn(true)} style={{
              cursor: "pointer", padding: "6px 12px", clipPath: facetTB(5), background: PANEL, boxShadow: RAISED,
              fontFamily: UI.fontD, fontSize: 10.5, letterSpacing: 2.4, color: UI.brassBright,
            }}>{auth.writable && auth.phase === "name" ? "PICK A NAME" : "PLAY WITH FRIENDS"}</div>
          )}
      </div>
      {signIn && <SignInCard auth={auth} onClose={() => setSignIn(false)} />}
      {markView === "view" && markUid && (
        <Mark uid={markUid} viewingSelf onClose={() => setMarkView(null)} onEdit={mine ? () => setMarkView("edit") : undefined} />
      )}
      {markView === "edit" && mine && <MarkEditor uid={auth.authUid} onClose={() => setMarkView(null)} />}
    </>
  );
}
